const Strings = {
  token_jwt: "lajsndjkandkjnbsakj",
  default_photo:
    "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg",
};

export default Strings;
